import {isSet,isEmpty,source} from './utils/common'
export function checkEmi(){
	if(validateEmiForm()){
		document.getElementById('spinner').classList.remove('hidden');
		//ajax
		$.ajax({
            url: "/homes/re2/homeloanEmiCalc?aj=1",
            type: "POST",
            data: {'homeloanEmiCalc' : JSON.stringify(homeloancalc.emiCalculator)},
            success: function (data) {
                if(!isEmpty(data)){
                    if(data['emi'] <= 0){
                    	document.getElementById('spinner').classList.add('hidden');
                        document.getElementById('error_message').innerHTML = 'Request not found. Please try again by changing values.';
                        document.getElementById('hc_error_popup').click();
                    }else {
                    	document.getElementById('spinner').classList.add('hidden');
                    	document.getElementById('hl_emi_response').classList.remove('opacity_otp');
                    	document.getElementById('emi_calc_emi_per_month').innerHTML = 'EMI &#8377; ' + data['emi'] + ' / Month';
                    }
                }else{
                	document.getElementById('spinner').classList.add('hidden');
                    document.getElementById('error_message').innerHTML = 'Request not found. Please try again by changing values.';
                    document.getElementById('hc_error_popup').click();
                }
            } 
        });

	}else {
		return false;
	}
}

export function resetEmicalcForm(){
	document.getElementById('emi_loan_amount').value = '';
	document.getElementById('emi_loan_tenure_year').value = '';
	document.getElementById('emi_loan_tenure_month').value = '';
	document.getElementById('emi_rate_of_interest').value = '';
	document.getElementById('emi_loan_amount_price').innerHTML = '';
	document.getElementById('emi_rate_of_interest_price').innerHTML = '';
	document.getElementById('hl_emi_response').classList.add('opacity_otp');
    document.getElementById('emi_calc_emi_per_month').innerHTML = 'EMI &#8377; 00.00 / Month';
}

function validateEmiForm(){
	let isEmiFormValid = true;
	//Emi loan amount check..
	if(!isEmiLoanAmountValid()) {
		isEmiFormValid = false;
	} 
	//Emi loan tenure year and month check
	if(!isEmiLoanTenureValid()){
		isEmiFormValid = false;
	}
	//Emi rate of interest check
	if(!isEmiRateOfInterestValid()){
		isEmiFormValid = false;
	}
	return isEmiFormValid;
}

function isEmiLoanAmountValid() {
	let emi_loan_amount = document.getElementById('emi_loan_amount').value;
	let regex = /^[0-9, ]+$/i;
	if(emi_loan_amount.match(regex) && emi_loan_amount !='') {
		HomeLoanCalculator.hideError('emi_loan_amount_error');
		homeloancalc.emiCalculator.emi_loan_amount = emi_loan_amount.replace(/,/g, '');
		return true;
	} else {
		let msg = "Enter valid loan amount";
		HomeLoanCalculator.showError('emi_loan_amount_error', msg);
		return false;
	}
}

export function isEmiLoanTenureValid() {
	let emi_loan_tenure_year = document.getElementById('emi_loan_tenure_year').value;
	let emi_loan_tenure_month = document.getElementById('emi_loan_tenure_month').value;
	if(emi_loan_tenure_year == '' && emi_loan_tenure_month == ''){
		let msg = "Enter valid loan tenure years or months";
		HomeLoanCalculator.showError('emi_loan_tenure_error', msg);
		return false;
	}else if(emi_loan_tenure_year != '' && emi_loan_tenure_month == ''){
		return isEmiLoanTenureYearValid(emi_loan_tenure_year);
	}else if(emi_loan_tenure_month != '' && emi_loan_tenure_year == ''){
		return isEmiLoanTenureMonthValid(emi_loan_tenure_month);
	}else {
		let emiYearTenure = isEmiLoanTenureYearValid(emi_loan_tenure_year);
		let emiMonthTenure = isEmiLoanTenureMonthValid(emi_loan_tenure_month);
		if(emiYearTenure && emiMonthTenure){
			HomeLoanCalculator.hideError('emi_loan_tenure_error');
			return true;
		}else if(!emiYearTenure){
			let msg = "Enter valid loan tenure years";
			HomeLoanCalculator.showError('emi_loan_tenure_error', msg);
		}else if(!emiMonthTenure){
			let msg = "Enter valid loan tenure months";
			HomeLoanCalculator.showError('emi_loan_tenure_error', msg);
		}
	}
		
}

function isEmiLoanTenureYearValid(emi_loan_tenure_year) {
	let regex = /^[0-9, ]+$/i;
	if(emi_loan_tenure_year.match(regex) && emi_loan_tenure_year !='') {
		HomeLoanCalculator.hideError('emi_loan_tenure_error');
		homeloancalc.emiCalculator.emi_loan_tenure_year = emi_loan_tenure_year.replace(/,/g, '');
		return true;
	} else {
		document.getElementById('emi_loan_tenure_year').value = '';
		let msg = "Enter valid loan tenure years";
		HomeLoanCalculator.showError('emi_loan_tenure_error', msg);
		return false;
	}
}

function isEmiLoanTenureMonthValid(emi_loan_tenure_month) {
	let regex = /^[0-9 ]+$/i;
	if(emi_loan_tenure_month !='' && emi_loan_tenure_month.match(regex) && emi_loan_tenure_month >= 0 && emi_loan_tenure_month < 12) {
		HomeLoanCalculator.hideError('emi_loan_tenure_error');
		homeloancalc.emiCalculator.emi_loan_tenure_month = emi_loan_tenure_month;
		return true;
	} else {
		document.getElementById('emi_loan_tenure_month').value = '';
		let msg = "Enter valid loan tenure months";
		HomeLoanCalculator.showError('emi_loan_tenure_error', msg);
		return false;
	}
}

function isEmiRateOfInterestValid() {
	let emi_rate_of_interest = document.getElementById('emi_rate_of_interest').value;
	let regex = /^[0-9. ]+$/i;
	if(emi_rate_of_interest.match(regex) && emi_rate_of_interest !='') {
		HomeLoanCalculator.hideError('emi_rate_of_interest_error');
		homeloancalc.emiCalculator.emi_rate_of_interest = emi_rate_of_interest.replace(/,/g, '');
		return true;
	} else {
		let msg = "Enter valid rate of interest";
		HomeLoanCalculator.showError('emi_rate_of_interest_error', msg);
		return false;
	}
}